import React, { Component } from 'react';

import PubSub from 'pubsub-js';
import Chip from 'material-ui/Chip';
import { connect } from 'react-redux';
import Avatar from 'material-ui/Avatar';
import Modal from 'react-awesome-modal';
import { Field, reduxForm } from 'redux-form';

import UserApi from '../../../../Logicas/UserApi';
import {
  minValue0,
  minValue1,
  required
} from '../../../validation/FormValidation';

import ButtonDefault, {
  LongTextField,
  TextFieldNumberInput,
  ButtonDisable,
  TextFieldDefault
} from '../../../utils/FormsComponents';

import IcoExit from '../../../utils/img/exit-dialog.png';
import ImgPlaceHolder from '../../../utils/img/place_holder_user.png';
import { TextFieldForm } from '../../../utils_form/FormComponents';
require('./dialog.css');
require('../form/formscoreusers.css');
class DialogTable extends Component {
  constructor() {
    super();
    this.state = {};
    this.removerUser = this.removerUser.bind(this);
    this.sendGift = this.sendGift.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
  }

  removerUser(user) {
    this.props.removeUserMarked(user);
    this.forceUpdate();
  }
  sendGift(values) {
    var users_ids = [];
    users_ids = this.props.list_marked.map(function(user) {
      return user.id;
    });
    this.setState({ score: values.score_pontuation.replaceAll('.', '') });
    if (
      this.props.check_all_users === true &&
      this.props.userFilter !== false
    ) {
      this.props.updateUserScoreByGiftByFilter(this.props.userFilter, {
        justification: values.justify,
        score: values.score_pontuation.replaceAll('.', '')
      });
    } else {
      this.props.updateUserScoreByGift(users_ids, {
        justification: values.justify,
        score: values.score_pontuation.replaceAll('.', '')
      });
    }
  }

  closeDialog(values) {
    values.score = '';
    values.justify = '';
    this.props.closeDialogGift();
    PubSub.publish('clear-list-marked', true);
  }

  render() {
    const { handleSubmit, submitting, isLoading } = this.props;
    let chipbody = {
      marginBottom: '5px',
      marginTop: '5px',
      marginRight: '5px',
      paddingLeft: '0px'
    };

    return (
      <Modal fadeInUp width="40%" height="80%" visible={this.props.visible}>
        <div className="container">
          {this.props.showModal ? (
            <div className="body-form-score">
              <div className="row-users">
                {this.props.check_all_users !== true && (
                  <label className="label-users-length">
                    Pontuar{' '}
                    {this.props.list_marked.length > 1 ? 'usuários' : 'usuário'}{' '}
                    ({this.props.list_marked.length})
                  </label>
                )}
                <img
                  onClick={this.closeDialog}
                  className="btn-exit"
                  src={IcoExit}
                  alt="fechar"
                />
              </div>
              <div className="display-chips">
                {this.props.check_all_users === true &&
                this.props.userFilter ? (
                  <div className="label-alert">
                    Todos os usuários filtrados por{' '}
                    {this.props.userFilter.selectedFilter ===
                    'Mês do Aniversário'
                      ? 'aniversário em '
                      : this.props.userFilter.filter_selectd.toLowerCase()}{' '}
                    {this.props.userFilter.filterValue === 'M' ||
                    this.props.userFilter.filterValue === 'F'
                      ? this.props.userFilter.filterValue === 'M'
                        ? ' masculino'
                        : ' feminino'
                      : this.props.userFilter.filterValue}{' '}
                    serão afetados.
                  </div>
                ) : (
                  Array.isArray(this.props.list_marked) &&
                  this.props.list_marked.map(
                    function(user) {
                      return (
                        <Chip backgroundColor="#efefef" style={chipbody}>
                          <Avatar
                            src={user.image ? user.image : ImgPlaceHolder}
                          />
                          {user.name}
                          <img
                            onClick={() => this.props.toggleSelectedUser(user)}
                            className="btn-remove-chip"
                            src={IcoExit}
                            alt="ícone remover"
                          />
                        </Chip>
                      );
                    }.bind(this)
                  )
                )}
              </div>
              <form className="form-to-score">
                <TextFieldForm
                  name="score_pontuation"
                  validate={[required, minValue0]}
                  id="name"
                  floatingLabelText="Pontuação"
                  type="text"
                  isFormattedNumber
                />
                <Field
                  name="justify"
                  validate={[required]}
                  id="name"
                  label="Justificativa"
                  component={LongTextField}
                  type="text"
                />
                <div style={{ width: '80%' }}>
                  <Field
                    disabled={true}
                    name="user_responsible"
                    id="name"
                    label="Responsável"
                    component={TextFieldDefault}
                    type="text"
                  />
                </div>
              </form>
              {this.props.list_marked.length > 0 &&
              this.props.valid &&
              !isLoading ? (
                <div className="submit-btn">
                  <ButtonDefault
                    onClick={handleSubmit(this.sendGift)}
                    label="Pontuar"
                  />
                </div>
              ) : (
                <div className="submit-btn">
                  <ButtonDisable height="40px" label="Pontuar" />
                </div>
              )}
            </div>
          ) : (
            <div>
              <div className="row-exit-confirm">
                <img
                  onClick={handleSubmit(this.closeDialog)}
                  className="btn-exit"
                  src={IcoExit}
                  alt="fechar"
                />
              </div>
              <div className="body-comfirm">
                <label className="label-comfirm-main">Pontuação enviada!</label>
                <label className="label-comfirm-secondary">
                  {this.props.list_marked.length > 1
                    ? this.props.list_marked.length + ' usuários, '
                    : this.props.list_marked.length + ' usuário, '}
                  {this.state.score > 1
                    ? Number(this.state.score).toLocaleString('pt-BR') +
                      ' pontos'
                    : Number(this.state.score).toLocaleString('pt-BR') +
                      ' ponto'}
                </label>
              </div>
            </div>
          )}
        </div>
      </Modal>
    );
  }
}
let DialogContainer = reduxForm({
  form: 'scoretousers'
})(DialogTable);

const mapStateToProps = (state) => {
  return {
    list_marked: state.user.selectedUsers.users,
    visible: state.dialog_score,
    initialValues: { user_responsible: localStorage.getItem('UserName') },
    showModal: state.show_modal_birthday,
    check_all_users: state.check_all_users,
    userFilter: state.user.userFilter,
    isLoading: state.dialog_pontuation_users.isLoading
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    closeDialogGift: () => dispatch(UserApi.closeDialogGift()),
    removeUserMarked: (user, checked) =>
      dispatch(UserApi.insertUserToEditScore(user, false)),
    updateUserScoreByGift: (user, gift) =>
      dispatch(UserApi.updateUserScoreByGift(user, gift)),
    resetDialog: () => dispatch({ type: 'SHOW_MODAL_BIRTHDAY' }),
    updateUserScoreByGiftByFilter: (filter, gift) =>
      dispatch(UserApi.updateUserScoreByGiftByFilter(filter, gift)),
    clearFilterStore: () => dispatch({ type: 'CLEAR_FILTER_USER' }),
    toggleSelectedUser: (selectedUser) => {
      dispatch({
        type: 'USER_SELECTED_TOGGLE',
        selectedUser
      });
    }
  };
};
DialogContainer = connect(mapStateToProps, mapDispatchToProps)(DialogContainer);
export default DialogContainer;
